var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViber(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 215 215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#7360f2;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Viber"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    className: "cls-1",
    cx: 107.5,
    cy: 107.5,
    r: 107.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Viber-2",
    "data-name": "Viber"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M148.37,343.83c-2.75-2.55-13.9-10.64-38.73-10.75,0,0-29.28-1.77-43.55,11.33-8,7.94-10.74,19.57-11,34s-.68,41.43,25.37,48.76h0v11.18s-.17,4.52,2.81,5.45c3.6,1.11,5.72-2.33,9.16-6,1.89-2,4.5-5,6.46-7.31,17.82,1.5,31.51-1.93,33.07-2.44,3.6-1.16,23.95-3.77,27.26-30.79C162.6,369.38,157.53,351.77,148.37,343.83Zm3,51.4c-2.79,22.55-19.3,24-22.34,24.95a92.89,92.89,0,0,1-28.46,2.42S89.32,436.2,85.8,439.74a1.89,1.89,0,0,1-1.63.66c-.6-.15-.77-.86-.76-1.91,0-1.5.09-18.58.09-18.58h0c-22-6.12-20.74-29.11-20.49-41.15s2.51-21.91,9.23-28.54c12.07-10.94,36.94-9.3,36.94-9.3,21,.09,31.07,6.41,33.4,8.53,7.75,6.64,11.7,22.51,8.81,45.77Z",
    transform: "translate(0 -277)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Viber-3",
    "data-name": "Viber",
    className: "cls-2",
    d: "M119.86,379.17a1.4,1.4,0,0,1-1.4-1.33c-.24-4.77-2.48-7.11-7.06-7.35a1.4,1.4,0,0,1,.14-2.8c6,.32,9.41,3.78,9.72,10a1.41,1.41,0,0,1-1.33,1.47Z",
    transform: "translate(0 -277)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Viber-4",
    "data-name": "Viber",
    className: "cls-2",
    d: "M127.06,381.59h0a1.41,1.41,0,0,1-1.37-1.44,16.27,16.27,0,0,0-4.19-11.88c-2.92-3.19-6.92-4.92-12.23-5.31a1.4,1.4,0,1,1,.2-2.8c6,.43,10.72,2.53,14.1,6.22a19.13,19.13,0,0,1,4.93,13.83A1.41,1.41,0,0,1,127.06,381.59Z",
    transform: "translate(0 -277)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Viber-5",
    "data-name": "Viber",
    className: "cls-2",
    d: "M134.44,384.47a1.4,1.4,0,0,1-1.4-1.39c-.07-8.47-2.61-15.21-7.56-20a26,26,0,0,0-18.63-7.36,1.41,1.41,0,0,1,0-2.81h0A28.71,28.71,0,0,1,127.44,361c5.51,5.37,8.33,12.78,8.4,22a1.39,1.39,0,0,1-1.39,1.41Z",
    transform: "translate(0 -277)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Viber-6",
    "data-name": "Viber",
    className: "cls-2",
    d: "M111.75,396.58a3.86,3.86,0,0,0,3-1.15l2.08-2.6a4.53,4.53,0,0,1,5.77-.8,59,59,0,0,1,5.15,3.28c1.56,1.16,4.77,3.83,4.78,3.83a4,4,0,0,1,.85,5.19v0a21.69,21.69,0,0,1-4.32,5.31l0,0a8.55,8.55,0,0,1-4.38,2.12,2.76,2.76,0,0,1-.64,0,5.88,5.88,0,0,1-1.86-.29l0-.07c-2.21-.62-5.9-2.18-12-5.57A70.72,70.72,0,0,1,100,399.26a51.18,51.18,0,0,1-4.55-4l-.16-.15-.15-.16h0l-.15-.15-.16-.15a54.36,54.36,0,0,1-4-4.55A71.67,71.67,0,0,1,84.09,380c-3.39-6.14-5-9.82-5.57-12l-.07,0a5.87,5.87,0,0,1-.28-1.86,2.72,2.72,0,0,1,0-.64A8.7,8.7,0,0,1,80.32,361s0,0,0,0a21.65,21.65,0,0,1,5.31-4.32h0a4,4,0,0,1,5.18.84s2.68,3.22,3.83,4.78S97,365.63,98,367.4a4.55,4.55,0,0,1-.8,5.77l-2.61,2.07a3.86,3.86,0,0,0-1.14,3S97.32,392.89,111.75,396.58Z",
    transform: "translate(0 -277)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViber);
export default __webpack_public_path__ + "static/media/Viber.80efbbe7f91e196f635a8d41bf9423bf.svg";
export { ForwardRef as ReactComponent };